import axios from "axios";

// Use relative URL to leverage Vite proxy
const API_BASE_URL = '/api/v1';

export const createCustomerAssessmentSession = async (payload) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/customer-assessment-session`, {
            ...payload,
            // Convert value to JSON string (API expects stringified JSON)
            value: JSON.stringify(payload.value),
            score_summary: payload.score_summary ? JSON.stringify(payload.score_summary) : null,
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error creating customer assessment session:", error);
        throw error.response?.data || { message: "Server error" };
    }
};

    export const createKdqol36Score = async (payload) => {
      try {
        const response = await axios.post(`${API_BASE_URL}/kdqol36-score`, {
          ...payload,
          score_summary: JSON.stringify(payload.score_summary || []),
        });

        return response.data;
      } catch (error) {
        console.error("❌ Error creating KDQOL-36 score:", error);
        throw error.response?.data || { message: "Server error" };
      }
    };

// export const getCustomerAssessmentBySessionAndType = async (session_id, type) => {
//     try {
//         const response = await axios.get(`${API_BASE_URL}/customer-assessment`, {
//             params: { session_id, type },
//         });
//         // return response.data;
//         return response.data.data;
//     } catch (error) {
//         console.error("❌ Error fetching assessment data:", error);
//         throw error.response?.data || error;
//     }
// };

export const getCustomerAssessmentBySessionAndType = async (session_id, type) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/customer-assessment`, {
            params: { session_id, type },
        });
        return response.data;
        // return response.data.data;
    } catch (error) {
        console.error("❌ Error fetching assessment data:", error);
        throw error.response?.data || error;
    }
};
export const getPostSessionScores = async (session_id) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/customer-assessment/post-session`,
      { params: { session_id } }
    );
    return response.data.data || []; // 🔥 return the array
  } catch (error) {
    console.error("❌ Error fetching post-session scores:", error);
    return []; // fallback to empty array
  }
};

export const getLatestHADSScoresByCustomer = async (customer_id) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/customer-assessment/latest-hads`,
      { params: { customer_id } }
    );
    return response.data.data || null;
  } catch (error) {
    console.error("❌ Error fetching latest HADS scores:", error);
    return null;
  }
};

export const getAssessmentCountsByCustomer = async (customer_id) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/customer-assessment/counts`,
      { params: { customer_id } }
    );
    return response.data.data || { hads: 0, eortc: 0, psqi: 0, kdqol: 0 };
  } catch (error) {
    console.error("❌ Error fetching assessment counts:", error);
    return { hads: 0, eortc: 0, psqi: 0, kdqol: 0 };
  }
};



// import axios from "axios";

// const API_BASE_URL = "/api/v1";

// export const createCustomerAssessmentSession = async (payload) => {
//   try {
//     const response = await axios.post(
//       `${API_BASE_URL}/customer-assessment-session`,
//       {
//         ...payload,
//         value: JSON.stringify(payload.value),
//       }
//     );

//     return response.data;
//   } catch (error) {
//     console.error("❌ Error creating customer assessment session:", error);
//     throw error.response?.data || { message: "Server error" };
//   }
// };

// export const getCustomerAssessmentBySessionAndType = async (
//   session_id,
//   type
// ) => {
//   try {
//     const response = await axios.get(
//       `${API_BASE_URL}/customer-assessment`,
//       {
//         params: { session_id, type },
//       }
//     );

//     return response.data.data; // 🔥 FIX
//   } catch (error) {
//     console.error("❌ Error fetching assessment data:", error);
//     throw error.response?.data || error;
//   }
// };

